// extracted by mini-css-extract-plugin
module.exports = {"ProductDraftsModal":"ProductDraftsModal_ProductDraftsModal__1yWv0"};